// TODO to delete the whole file after scrollable calendar UI PR is merged

export const color_mood_mellow_mellow_yellow_300 = '#fff0d7';
export const color_neutral_200 = 'var(--color-neutral-200, #efedf2)';
export const color_neutral_500 = 'var(--border-border-secondary, #dddae3)';
export const color_mood_mellow_mellow_pink_300 = '#feedea';
export const base_color = '#FFF';
export const color_loading_bg =
    'linear-gradient(90deg, rgba(255, 255, 255, 0.18) 31.05%, rgba(0, 0, 0, 0.00) 65.45%, rgba(255, 255, 255, 0.11) 65.45%), #EEEDF2';
